// src/environments/environment.ts
import { Environment } from './environment.model';
export const environment: Environment = {
  production: false,
  stage: 'PREP',
  region: 'NAFTA',
  apiBaseUrls: {
    NAFTA: 'https://19q6i75fh9.execute-api.us-east-1.amazonaws.com/fcl/v1'
  },
  cognitoConfigs: {
    NAFTA: {
      aws_project_region: 'us-east-1',
      aws_cognito_region: 'us-east-1',
      aws_user_pools_id: 'us-east-1_XRNU7JC7Z',
      aws_user_pools_web_client_id: '6blhs0i9v4nhhiogvnl9f9900f',
    }
  },
  zuoraEntity: ['NAFTA', 'MAS_NAFTA', 'LATAM']
};